function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { _translate as t, _Notifications } from "../../../../../services/core";
import 'bootstrap-slider/dist/css/bootstrap-slider.css';
import FixedTime from "./fixed";

/**
 * Time slider (simple)
 * Time range slider (simple choix : plage horaire)
 *
 * On enregistre 3 valeurs (min, mid, max)
 *
 * @see https://github.com/brownieboy/react-bootstrap-slider
 */
var PlageInput = function PlageInput(props) {
  var onChangeValue = props.onChangeValue,
    value = props.value;
  var onChangeFixedTimeValue = function onChangeFixedTimeValue(obj, type) {
    var max = type === 'max' ? obj.mid : value.max;
    var min = type === 'min' ? obj.mid : value.min;
    var dteMax = new Date("1970-01-01T".concat(max.replace('h', ':'), ":00"));
    var dteMin = new Date("1970-01-01T".concat(min.replace('h', ':'), ":00"));
    localStorage.setItem('min', dteMin);
    localStorage.setItem('max', dteMax);
    var hourmin = parseInt(min.split('h')[0]);
    var minutemin = parseInt(min.split('h')[1]);
    var hourmax = parseInt(max.split('h')[0]);
    var minutemax = parseInt(max.split('h')[1]);
    var newres = (hourmax * 60 + minutemax + (hourmin * 60 + minutemin)) / 2;
    var hourmid = (newres - newres % 60) / 60 < 10 ? '0' + (newres - newres % 60) / 60 : (newres - newres % 60) / 60;
    var minutemid = Math.floor(newres % 60);
    newres = hourmid + 'h' + minutemid;
    onChangeValue(_objectSpread(_objectSpread({}, value), {}, _defineProperty(_defineProperty({}, type, obj.mid), "mid", newres)));
  };
  return /*#__PURE__*/React.createElement(Row, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: 'auto'
    }
  }, /*#__PURE__*/React.createElement(FixedTime, {
    value: {
      mid: value === null || value === void 0 ? void 0 : value.min
    },
    onChangeValue: onChangeFixedTimeValue,
    type: "min"
  }), /*#__PURE__*/React.createElement(Col, {
    className: "tag align-self-center hourly-margin"
  }, /*#__PURE__*/React.createElement("div", null, t('collectorapp_and'))), /*#__PURE__*/React.createElement(FixedTime, {
    value: {
      mid: value === null || value === void 0 ? void 0 : value.max
    },
    onChangeValue: onChangeFixedTimeValue,
    type: "max"
  }));
};
PlageInput.propTypes = {
  onChangeValue: PropTypes.func.isRequired
};
PlageInput.defaultProps = {
  responses: {}
};
export default PlageInput;